import { Table } from "rsuite"

export default function StatusCell({ rowData, ...props }: any) {
  return (
    <Table.Cell {...props} style={{ background: 'none' }}>
      <p className={rowData.isCompleted && 'match-status'}>{rowData.isCompleted ? 'Completed' : 'Live'}</p>
    </Table.Cell>
  )
}